module.exports = __webpack_public_path__ + "img/15.98f45370.svg";